module.exports = __webpack_public_path__ + "img/public/AdminIcons/gotoMainIcon.svg?3cdd33e5";